import { render, staticRenderFns } from "./PuzzlePiece.vue?vue&type=template&id=7df6fc58"
import script from "./PuzzlePiece.vue?vue&type=script&lang=js"
export * from "./PuzzlePiece.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports